import React, { useState } from 'react';

type ToastProps = {
  type?: 'info' | 'success' | 'warning' | 'error';
  message?: string;
  title?: string;
  onClose?: () => void;
};

const Toast: React.FC<ToastProps> = ({
  type = 'info', // "info", "success", "warning", "error"
  message = 'This is a toast notification!',
  title = 'Notification',
  onClose,
}) => {
  const typeClasses: Record<string, string> = {
    info: 'bg-blue-100 border-blue-400 text-blue-700',
    success: 'bg-green-100 border-green-400 text-green-700',
    warning: 'bg-yellow-100 border-yellow-400 text-yellow-700',
    error: 'bg-red-100 border-red-400 text-red-700',
  };

  return (
    <div
      className={`border px-4 py-3 rounded relative ${typeClasses[type] || typeClasses.info} shadow-lg max-w-sm sm:max-w-md mx-auto mt-4`}
      role="alert"
      aria-live="assertive"
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <strong className="font-bold block sm:inline">{title}</strong>
          <span className="block sm:inline ml-2">{message}</span>
        </div>
        <span className="ml-4 cursor-pointer flex-shrink-0" onClick={onClose}>
          <svg
            className="fill-current h-6 w-6"
            role="button"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <title>Close</title>
            <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
          </svg>
        </span>
      </div>
    </div>
  );
};
export const ToastExample = () => {
  const [showToast, setShowToast] = useState(false);

  return (
    <div>
      <button
        onClick={() => setShowToast(true)}
        className="bg-green-500 text-white px-4 py-2 rounded"
      >
        Show Success Toast
      </button>

      {showToast && (
        <Toast
          type="success"
          title="Success!"
          message="Your operation was completed successfully."
          onClose={() => setShowToast(false)}
        />
      )}
    </div>
  );
};

export default Toast;
